import APILibrary, { ClassExtender, GenerateResource } from './APILibrary';
import {
  JobApplicationAttributes,
  JobApplicationBelongsTo,
  JobApplicationHasMany,
  JobApplicationInterface,
  JobApplicationResource,
  JobApplicationResourceClass,
} from './JobApplication';

/**
 * Relationship classes
 */
// TODO: Meta?
class EmployerJobApplicationMeta {
  awaitingReviewCount: number;
  reviewedCount: number;
  rejectedCount: number;
}

/**
 * Utility interfaces
 */
export interface EmployerJobApplicationResource extends JobApplicationResource {}

/**
 * Resource methods
 */
const BaseClass = () =>
  GenerateResource<JobApplicationAttributes>({
    queryName: 'employer/job_applications',
    className: 'EmployerJobApplication',
    AttributesClass: JobApplicationAttributes,
    BelongsToClasses: [
      {
        Klass: JobApplicationBelongsTo,
      },
    ],
    HasManyClasses: [
      {
        Klass: JobApplicationHasMany,
      },
    ],
  });

export class EmployerJobApplicationResource extends ClassExtender<JobApplicationInterface>(
  BaseClass,
  JobApplicationResourceClass,
) {}

/**
 * Resource instance
 */
export const EmployerJobApplication = APILibrary.createResource<
  EmployerJobApplicationResource,
  EmployerJobApplicationMeta
>(EmployerJobApplicationResource);
